import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const updateCheck = (axios: IAxiosInstance) => {
  return async (requestBody: ISchema["#/definitions/IUpdateCheckRequest"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/IUpdateCheckResponse"]
    >(`api/updateCheck`, requestBody);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
